import { logout } from '../HttpRequests/auth';
import { unsetToken } from '../Actions/token';

export default () => async (dispatch) => {

  try {

    await logout();

    dispatch(unsetToken());

    window.location = '/login';

  } catch (error) {

    console.log(error);

    throw error;

  }
}
